/* import __COLOCATED_TEMPLATE__ from './chip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();